class RichTextComponent extends HTMLElement {
  constructor() {
    super();
    this.expanded = false;
    this.truncateLength = parseInt(this.getAttribute('truncate-length')) || 195;
    this.toggle = this.toggle.bind(this);
    this.readmoreText = this.getAttribute('readmore-text') || 'Read more';
    this.readlessText = this.getAttribute('readless-text') || 'Read less';
  }

  connectedCallback() {
    this.fullText = this.textContent.trim();
    this.innerHTML = '';

    this.contentEl = document.createElement('span');
    this.contentEl.classList.add('content');
    this.contentEl.textContent = this.truncateText(this.fullText);

    this.appendChild(this.contentEl);

    if (this.truncateLength < this.fullText.length) {
      this.btn = document.createElement('a');
      this.btn.classList.add('toggle-element');
      this.btn.textContent = this.readmoreText;
      this.btn.addEventListener('click', this.toggle);

      this.appendChild(this.btn);
    }
  }

  truncateText(text) {
    if (text.length <= this.truncateLength) return text;
    return text.slice(0, this.truncateLength);
  }

  toggle() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.contentEl.textContent = this.fullText;
      this.btn.textContent = this.readlessText;
      this.btn.classList.add('read-more');
    } else {
      this.contentEl.textContent = this.truncateText(this.fullText);
      this.btn.textContent = this.readmoreText;
      this.btn.classList.remove('read-more');
    }
  }

  disconnectedCallback() {
    this.btn.removeEventListener('click', this.toggle);
  }
}

customElements.define('rich-text-component', RichTextComponent);
